import React from 'react';

import { ContentText } from './styles';

const MessageInvalidCard = ({ inValidCards, getName }) => {
  if (inValidCards.length < 1)
    throw new Error('A propriedade "inValidCards" deve ter pelo menos um item');

  const novasParametrizacoes = Array.from(
    new Set(inValidCards.map((c) => getName(c.tipoParametrizacao, c)))
  );

  const parametrizacoesVinculadas = Array.from(
    new Set(
      inValidCards.map((c) => getName(c.vinculo.tipoParametrizacao, c.vinculo))
    )
  );

  const qtdInvalidCards = novasParametrizacoes.length;
  const SINGULAR = qtdInvalidCards === 1;

  return (
    <ContentText>
      {SINGULAR ? 'A parametrização: ' : 'As parametrizações: '}
      {novasParametrizacoes.map((nameParametrizacao, index) => (
        <strong key={nameParametrizacao}>
          {SINGULAR || index + 1 === qtdInvalidCards
            ? nameParametrizacao
            : `${nameParametrizacao}${
                index + 2 === qtdInvalidCards ? ' e ' : ', '
              }`}
        </strong>
      ))}
      {SINGULAR
        ? `, não foi adicionada pois já está parametrizada. Para realizar a nova
      parametrização é necessário remover a parametrização `
        : `, não foram adicionadas pois já estão parametrizadas. Para realizar as
        novas parametrizações é necessário remover a parametrização `}
      {parametrizacoesVinculadas.map((nomeVinculo, index) => (
        <strong key={nomeVinculo}>
          {parametrizacoesVinculadas.length === 1 ||
          index + 1 === parametrizacoesVinculadas.length
            ? nomeVinculo
            : `${nomeVinculo}${
                index + 2 === parametrizacoesVinculadas.length ? ' e ' : ', '
              }`}
        </strong>
      ))}{' '}
      com a qual possui vínculo.
    </ContentText>
  );
};

export default MessageInvalidCard;
